/*eslint-disable*/

import { isEmpty }           from "lodash";

import { CashRegisterModel } from '../../../../components/Shop/CashRegisters/types'
import { Customer } from '../../../../components/Shop/Notices/types'
import { InvoiceInfo } from '../../includes/types/Shared/InvoiceInfo.types'
import PostApi from "./Api/PostApi";
import { PaymentMethods } from '../../../../components/ServicesCart/logic/types'
import { PaymentTargetConfig } from '../types/Config'

export default class Payment {
  target_id              = null;
  target_type            = "";
  tariff                 = "";
  shop                   = "";
  monthCount             = "";
  shopRequiredFieldsData = "";

  constructor(target_id:any, target_type:any, tariff:any, shop:any, monthCount:any, shopRequiredFieldsData:any) {
    this.target_id              = target_id;
    this.target_type            = target_type;
    this.tariff                 = tariff;
    this.shop                   = shop;
    this.shopRequiredFieldsData = shopRequiredFieldsData;
    this.monthCount             = monthCount;
  }

  static get shopsPriorityList() {
    return [ "local", "global", "crypto" ];
  }

  static get shopsGetawayPriorityCodeList() {
    return {
      "local": [ "sberbank_business" ],
    };
  }

  get payment() {
    const payment = {
      target_id   : this.target_id,
      target_type    : this.target_type,
      tariff    : this.tariff,
      shop      : this.shop,
      monthCount: this.monthCount,
    } as any;

    if(!isEmpty(this.shopRequiredFieldsData)) {
      payment.params = this.shopRequiredFieldsData;
    }

    return payment;
  }

  static getItemCurrencyShopSymbolsList(item:any) {
    const list:any = {};

    for(const shopKey in item.shops) {
      if(item.shops.hasOwnProperty(shopKey)) {
        list[ shopKey ] =
          item.shops[ shopKey ]
            .slice()
            .map((val:any) => val.currency_symbol)
            .filter((value:any, index:number, self:any) => self.indexOf(value) === index);
      }
    }

    return list;
  }

  // static getItemPriceInfo(item) {
  //   for(let i = 0; this.shopsPriorityList.length; i++) {
  //     const priorityShopKey = this.shopsPriorityList[ i ];
  //     if(!isUndefined(item.shops[ priorityShopKey ])) {
  //       const shop = item.shops[ priorityShopKey ][ 0 ];
  //
  //       if(has(item.shops, priorityShopKey)) return {
  //         price                     : shop.price,
  //         base_price                : shop.base_price,
  //         currency_code             : shop.currency_code,
  //         currency_short_name       : shop.currency_short_name,
  //         currency_symbol           : shop.currency_symbol,
  //         currency_name             : shop.currency_name,
  //         currency_shop_symbols_list: this.getItemCurrencyShopSymbolsList(item),
  //         currency_shop_default     : priorityShopKey,
  //       };
  //     }
  //   }
  // }

  static getPayMethods({ target_type, target_id }: PaymentTargetConfig):Promise<{data: PaymentMethods}> {
    return PostApi.sendRequest('tg', 'getpaymethods', {
      target_id,
      target_type,
    });
  }

  createPayment(promocode = "") {
    return new Promise((resolve, reject) => {
      const payment = this.payment;
      if(promocode !== "") {
        payment.promocode = promocode;
      }
      PostApi.sendRequest("tg", 'createPayment', this.preparePaymentObject(payment))
        .then(res => {
          window.location.href = res.data.url;
          resolve(res.data);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  }

  preparePaymentObject({ target_id, invoice_key, target_key, target_type, tariff, shop, monthCount, params, promocode }: {target_id:any, invoice_key:any, target_key:any, target_type:any, tariff:any, shop:any, monthCount:any, params:any, promocode:any}) {
    const payment = {
      target_type,
      tariff,
      shop,
      'month_count': monthCount,
    } as any;

    if(target_id) {
      payment.target_id = target_id;
    }
    if(invoice_key) {
      payment.invoice_key = invoice_key;
    }
    if(target_key) {
      payment.target_key = target_key;
    }
    if(params) {
      payment.params = params;
    }
    if(promocode) {
      payment.promocode = promocode;
    }
    return payment
  }

  static getPayInfo(invoice: string): Promise<{ data: { invoice: InvoiceInfo } }> {
    return PostApi.sendRequest("tg", 'getPayInfo', { invoice });
  }

  static getNoticePayInfo(token: any):Promise<{ data: NoticePayInfoRes }> {
    return PostApi.sendRequest("tg", 'GetNoticePayStatus', { token });
  }

  static sort(shops:any) {
    return shops.sort((a:any, b:any) => {
      return b[ "weight" ] - a[ "weight" ];
    });
  }

  // TODO
  // static isVerifiedChatLicenseBuyQueryParams(query) {
  //   // TODO ChatLicense.LICENSE_TYPE
  //   return Object.values(ChatLicense.LICENSE_TYPES).includes(query.tariff) && Object.values(ChatLicense.MONTH_COUNT).includes(parseInt(query.monthCount));
  // }

  static runCoupon(target_id:any, target_type:any, promocode:any):Promise<{data: PaymentMethods}> {
    return PostApi.sendRequest('tg', 'getpaymethods', {
      target_id,
      target_type,
      promocode,
    });
  }
}

export type NoticePayInfoRes = {
  notice: NoticePayInfo
  bot: NoticeBotInfo
  url: string
}

export type NoticeBotInfo = {
  id: number
  username: string
  title: string
  avatar_url: string
  url: string
}


export type NoticePayInfo = {
  id: number
  cashRegister: CashRegisterModel
  customer: Customer
  date: string
  sum: number
  discount_sum: number
  total: number
  details: Array<Detail>
  payment: {
    date: string
    id: null
  }
}

type Detail = {
  product: {

  }
  cost: number
  count: number
  sum: number
  total: number
}
